import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { MapLocationBlockConfig } from '@front-platform/content-builder';
import { mapLocationBlockResolveConfig } from '@front-platform/content-builder';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { Component, OnDestroy, OnInit, input } from '@angular/core';

import { PlaceResult } from '@core/models/google-maps.model';
// TODO: Move this ts file inside app folder
import { googleMapsSilverTheme } from '@styles/googleMapsSilverTheme';

import { GoogleMapsApiHelper } from '@common/helpers/google-maps-api.helper';
export interface MapLocationBlockRuntimeConfig {}

export type MapLocationBlockConfigInput = Partial<
  Omit<MapLocationBlockConfig, keyof MapLocationBlockRuntimeConfig> & MapLocationBlockRuntimeConfig
>;
export type MapLocationBlockResolvedConfig = Omit<
  MapLocationBlockConfig,
  keyof MapLocationBlockRuntimeConfig
> &
  Partial<MapLocationBlockRuntimeConfig>;
export interface MapLocationBlockContract extends ConfigComponentContract<
  MapLocationBlockConfigInput,
  MapLocationBlockResolvedConfig
> {}
import { selectedMarkerMarkerConfig } from '@shared/blocks/shops-map-block/config/shops-map-block.config';

@Component({
  selector: 'app-map-location-block',
  templateUrl: './map-location-block.component.html',
  standalone: false,
})
export class MapLocationBlockComponent implements OnInit, OnDestroy, MapLocationBlockContract {
  readonly config = input<MapLocationBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    MapLocationBlockConfig,
    MapLocationBlockRuntimeConfig
  >(mapLocationBlockResolveConfig, () => ({ config: this.config() }));
  private _destroyRef = new Subject<boolean>();

  get name(): string {
    return this.resolvedConfig()['name'] as unknown as string;
  }
  get address(): PlaceResult {
    return this.resolvedConfig()['address'] as unknown as PlaceResult;
  }

  isMapLoaded = false;

  mapZoom = 13;
  mapMinZoom = this.mapZoom;
  mapMaxZoom = this.mapZoom;
  mapStyle = googleMapsSilverTheme;
  mapOptions: google.maps.MapOptions = {
    zoom: this.mapZoom,
    styles: this.mapStyle,
    disableDefaultUI: true,
    maxZoom: this.mapMaxZoom,
    minZoom: this.mapMinZoom,
    center: this.address?.geometry?.location,
  };

  mapOptionCenter = this.address?.geometry?.location as unknown as
    google.maps.LatLngLiteral | google.maps.LatLng;

  markerIcon = selectedMarkerMarkerConfig as google.maps.Icon | google.maps.Symbol;
  markerOptions: google.maps.MarkerOptions = { draggable: false };

  constructor(private googleMapsHelper: GoogleMapsApiHelper) {}

  ngOnInit(): void {
    this.googleMapsHelper
      .ensureLoaded$()
      .pipe(take(1), takeUntil(this._destroyRef))
      .subscribe(() => {
        if (this.isMapLoaded) {
          return;
        }
        this.mapOptions = {
          ...this.mapOptions,
          center: this.address?.geometry?.location,
        };
        this.mapOptionCenter = this.address?.geometry?.location as unknown as
          google.maps.LatLngLiteral | google.maps.LatLng;
        this.markerOptions = {
          ...this.markerOptions,
          label: {
            ...Object(this.markerOptions.label ?? {}),
            text: this.name,
          },
        };
        this.isMapLoaded = true;
      });
  }

  ngOnDestroy(): void {
    this._destroyRef.next(true);
    this._destroyRef.complete();
  }
}

COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(MapLocationBlockComponent, { keyAliases: {} });
